import * as React from 'react';

import Filter from '../../_common/filter';
import { getText, getConfig } from '../../../helpers';

const clearAllText = getText('generic.clearAll');
const filterTitles = getText('pages.dataSets.filterOptions');
const filterOptions = getConfig('components.filterOptions');

const DataFiltersDropDown = ({ filters, onUpdate, handleClearAll, isFiltersActive }: DataFiltersDropdownProps) => {
    const onClearAll = (event: React.SyntheticEvent) => {
        event.preventDefault();
        handleClearAll();
    };
    return (
        <>
            <div className="data-filters-dropdown">
                {filters.map((filter: FilterObjects) => (
                    <Filter
                        isRadio={filter.filterKey === filterOptions.history.filterKey}
                        key={filter.filterKey}
                        filterKey={filter.filterKey}
                        filterTitle={filterTitles[filter.filterKey].text}
                        filterItems={filter.items}
                        onUpdate={onUpdate}
                        showSearch={filter.showSearch}
                    />
                ))}
                {isFiltersActive && (
                    <button type="button" className="button data-filters-dropdown__clear-all" onClick={onClearAll} data-testid="data-filters-dropdown-clear-all">
                        {clearAllText}
                    </button>
                )}
            </div>
        </>
    );
};
export default DataFiltersDropDown;
